import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.PRODUCT_SET_PRODUCT_AND_STOCK_LIST]: (state, payload) => {
    state.productAndStockList = payload.productList
  },
  [mutationsTypes.PRODUCT_SET_PRODUCT_LIST]: (state, payload) => {
    state.productList = payload.productList
  },
  [mutationsTypes.PRODUCT_SET_MAKER_LIST]: (state, payload) => {
    state.makerList = payload.makerList
  }
}

export default Mutations
